import styled from '@emotion/styled';

const CardContainer = styled.div`
  display: flex;
  width: 100%;

  [data-lift='lft-cardshape'] {
    width: 100%;
    height: 100%;
    min-width: 48px;
    min-height: 24px;
    overflow: unset;
  }

  [data-lift='lft-cardbase'] {
    width: 100%;
    height: 100%;
  }
`;

const S = {
  CardContainer,
};

export default S;
